import React from 'react';
import {
  CharacterSummaryContainer,
  SummaryTitle,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
  ActionButtonsContainer,
  ActionButton,
  CharacterImage,
  CharacterImageContainer,
  SummaryItemsContainer,
} from './CharacterStyles';
import { ATTRIBUTE_OPTIONS_MAP } from './characterConstants';
import { transformKeyToTitle } from './charactersUtils';
import { useCharacter } from './CharacterContext';
import { FaMagic } from 'react-icons/fa';

interface CharacterSummaryProps {
  onCreateCharacter: () => void;
}

const CharacterSummary: React.FC<CharacterSummaryProps> = ({
  onCreateCharacter,
}) => {
  const { character } = useCharacter();
  // Get a label for an attribute value
  const getAttributeLabel = (key: string, value: string | string[]) => {
    if (!value) return 'Not specified';

    const options =
      ATTRIBUTE_OPTIONS_MAP[key as keyof typeof ATTRIBUTE_OPTIONS_MAP];
    if (!options) return value.toString();

    if (Array.isArray(value)) {
      return value
        .map((v) => options.find((o) => o.id === v)?.label || v)
        .join(', ');
    }

    return options.find((o) => o.id === value)?.label || value;
  };

  return (
    <CharacterSummaryContainer>
      <SummaryTitle>Character Summary</SummaryTitle>

      <CharacterImageContainer>
        <CharacterImage src={character._imageUrl} alt="Character" />
      </CharacterImageContainer>

      <SummaryItemsContainer>
        {Object.entries(character).map(([key, value]) => {
          // Skip empty values or internal keys
          if (!value || key.startsWith('_')) return null;

          return (
            <SummaryItem key={key}>
              <SummaryLabel>{transformKeyToTitle(key)}:</SummaryLabel>
              <SummaryValue>{getAttributeLabel(key, value)}</SummaryValue>
            </SummaryItem>
          );
        })}
      </SummaryItemsContainer>

      <ActionButtonsContainer>
        <ActionButton variant="primary" onClick={onCreateCharacter}>
          Create Character <FaMagic />
        </ActionButton>
      </ActionButtonsContainer>
    </CharacterSummaryContainer>
  );
};

export default CharacterSummary;
